<template>
  <div class="container mt-4">
    <div class="row">
      <div class="ml-auto">
        <my-button fa="" label="Add new Customer" variant="box-general" classes="mr-1" height="48px" width="200px" @onClick="showAddNewCustomerModal()"></my-button>
      </div>
    </div>

    <div class="row">
      <div class="customer col-md-12 mb-4 mt-4" :key="customer.id" v-for="customer in customers">
        <div class="row">
          <h4 class="font-weight-bold">
            {{ customer.name }}
          </h4>
          <br />
        </div>
        <div class="row">
          <small
            >Customer Instnace ID : <b>{{ customer.customerid }}</b></small
          >
        </div>
        <b-form @submit.stop.prevent="updateCustomer(customer.id)">
          <div class="row mt-3">
            <div class="col-md-6">
              <my-input id="customer" name="customer" label="Customer" mandatory="true" placeholder="" inlinerows="true" variant="test" inlineLabelClass="col-sm-4" inlineInputClass="col-sm-8" :defaultText="customer.name" :ref="'customer_' + customer.id"></my-input>
            </div>
            <div class="col-md-6">
              <my-input id="organizationNumber" name="organizationNumber" label="Organization Number" mandatory="true" placeholder="" inlinerows="true" variant="test" inlineLabelClass="col-sm-4" inlineInputClass="col-sm-8" :ref="'organization_number_' + customer.id" :defaultText="customer.organization_number"></my-input>
            </div>
            <div class="col-md-6">
              <my-input id="guid" name="guid" label="GUID" mandatory="true" placeholder="" inlinerows="true" variant="test" inlineLabelClass="col-sm-4" inlineInputClass="col-sm-8" :defaultText="customer.guid" :ref="'guid_' + customer.id"></my-input>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-6">
              <my-input id="secretKey" name="secretKey" label="Secret Key" mandatory="true" placeholder="" inlinerows="true" variant="test" inlineLabelClass="col-sm-4" inlineInputClass="col-sm-8" :defaultText="customer.secret_key" :ref="'secret_key_' + customer.id"></my-input>
            </div>
            <div class="col-md-6">
              <selector id="licenseType" name="licenseType" mandatory="true" label="License Type" placeholder="" :data="subscriptions" :valuefield="valuefield" :textfield="textfield" inlinerows="true" inlineLabelClass="col-sm-4" inlineSelectClass="col-sm-8" :selected="activeSubscription(customer)" :ref="'license_type_' + customer.id"></selector>
            </div>
            <div class="col-md-6">
              <my-input id="lmsUrl" name="lmsUrl" label="LMS URL" mandatory="true" placeholder="" inlinerows="true" variant="test" inlineLabelClass="col-sm-4" inlineInputClass="col-sm-8" :defaultText="customer.lms_url" :ref="'lms_url_' + customer.id"></my-input>
            </div>

            <div class="col-md-6">
              <my-input id="lmsEmail" name="lmsEmail" label="Email" mandatory="true" placeholder="" inlinerows="true" variant="test" inlineLabelClass="col-sm-4" inlineInputClass="col-sm-8" :defaultText="customer.email" :ref="'lms_email_' + customer.id"></my-input>
            </div>

            <div class="col-md-12">
              <hr />
            </div>
          </div>

          <div class="row mt-3 mb-3 customer-settings">
            <div class="col-md-12">
              <div class="row mb-3">
                <h5><b>Customer Settings</b></h5>
              </div>

              <div class="row">
                <div v-for="setting in settings" v-bind:key="setting.id" class="col-md-6 mb-4">
                  <my-input :id="setting.id" :name="setting.name + '_' + customer.id" inlinerows="true" inlineLabelClass="col-sm-4" inlineInputClass="col-sm-8" :label="setting.display_name" :placeholder="setting.value" :type="setting.type" :ref="setting.name + '_' + customer.id" :defaultText="getActualSettingValue(setting.id, setting.value, customer.customer_settings)"></my-input>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <hr />
            </div>
          </div>

          <div class="row mt-3 mb-3 customer-">
            <h5><b>Stripe Connect Account</b></h5>

            <div class="ml-auto mb-2">
              <my-button fa="plus" label="Create Account" variant="box-general" classes="mr-1" height="48px" width="200px" @onClick="showCreateAccountModal(customer)"></my-button>
            </div>

            <div class="col-md-12">
              <b-table :items="customer.stripe_connect_account" :fields="stripeCATableFields" striped responsive="sm">
                <template #cell(update_status)="row">
                  <toggle-simple ref="account_status" labelEnable="" labelDisable="" :checked="row.item.status == 'active'" @toggle="updateAccountStatus($event, row.item)" />
                </template>
                <template #cell(actions)="row">
                  <my-button fa="trash" label="" variant="box-general" classes="mr-1 mb-1 text-danger" @onClick="showAccountDeletionModal(row.item)"></my-button>
                </template>
              </b-table>
            </div>
            <div class="col-md-12">
              <hr />
            </div>
          </div>

          <div class="row">
            <div class="mr-auto">
              <!-- <my-button
                fa=""
                label="Synchronize with LMS"
                variant="link"
                classes="btn-link"
                height="48px"
                width="200px"
              ></my-button> -->
            </div>
            <div class="ml-auto">
              <my-button type="submit" fa="" label="Save Settings" variant="box-general" classes="mr-1" height="48px" width="200px"></my-button>
            </div>
          </div>
        </b-form>

        <div class="row">
          <div class="col-md-12 mt-3 mb-3">
            <hr />
          </div>
        </div>
      </div>
    </div>

    <b-modal title="Add New Customer" v-model="addNewCustomerModalShow" size="xl" hide-footer ref="addNewCustomer" :static="true" :no-close-on-backdrop="true">
      <b-form ref="addNewCustomerDataForm" @submit.stop.prevent="addNewCustomer()">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <my-input id="newCustomer" name="newCustomer" label="Customer" mandatory="true" placeholder="" inlinerows="true" variant="test" inlineLabelClass="col-sm-4" inlineInputClass="col-sm-8" ref="newCustomer"></my-input>
            </div>
            <div class="col-md-6">
              <my-input id="newOrgNumber" name="newOrgNumber" label="Organization Number" mandatory="true" placeholder="" inlinerows="true" variant="test" inlineLabelClass="col-sm-4" inlineInputClass="col-sm-8" ref="newOrgNumber"></my-input>
            </div>
            <div class="col-md-6">
              <my-input id="newGuid" name="newGuid" label="GUID" mandatory="true" placeholder="" inlinerows="true" variant="test" inlineLabelClass="col-sm-4" inlineInputClass="col-sm-8" ref="newGuid"></my-input>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-6">
              <my-input id="newSecretKey" name="newSecretKey" label="Secret Key" mandatory="true" placeholder="" inlinerows="true" variant="test" inlineLabelClass="col-sm-4" inlineInputClass="col-sm-8" ref="newSecretKey"></my-input>
            </div>

            <div class="col-md-6">
              <selector id="newLicense" name="newLicense" label="License Type" mandatory="true" placeholder="" :data="subscriptions" :valuefield="valuefield" :textfield="textfield" inlinerows="true" inlineLabelClass="col-sm-4" inlineSelectClass="col-sm-8" ref="newLicense"></selector>
            </div>

            <div class="col-md-6">
              <my-input id="newLmsUrl" name="newLmsUrl" label="LMS URL" mandatory="true" placeholder="" inlinerows="true" variant="test" inlineLabelClass="col-sm-4" inlineInputClass="col-sm-8" ref="newLmsUrl"></my-input>
            </div>

            <div class="col-md-6">
              <my-input id="customerEmail" name="customerEmail" label="Customer Email" mandatory="true" placeholder="" inlinerows="true" variant="test" inlineLabelClass="col-sm-4" inlineInputClass="col-sm-8" ref="customerEmail"></my-input>
            </div>
          </div>
          <div class="row">
            <small>Important : Customer Instnace ID generated automatically, is an increment of the last generated ID</small>
          </div>
        </div>

        <div class="modal-footer">
          <my-button label="Cancel" variant="box-general-grey" classes="mr-1" height="46px" minwidth="100px" @onClick="hideModal('addNewCustomerModalShow')"></my-button>
          <my-button type="submit" label="Save" variant="solid-primary" classes="mr-1" height="46px" minwidth="100px"></my-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="create-account-modal" title="Create Account" hide-footer>
      <b-form ref="createAccountForm" @submit.stop.prevent="createAccount">
        <my-input id="account-name" name="account-name" label="Account Name" mandatory="true" placeholder="" inlinerows="false" v-model="createModal.stripe_connect_account.name" type="text"></my-input>

        <my-button label="Create Account" variant="solid-primary" classes="mt-4" height="56px" width="100%" type="submit"></my-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
/**
 * Sparkfore Admin - Manage Customers Page
 */
import MyButton from "../../components/atoms/Button.vue";
import MyInput from "../../components/atoms/Input.vue";
import Selector from "../../components/atoms/Selector.vue";
import ToggleSimple from "../../components/atoms/ToggleSimple.vue";

export default {
  name: "manage-customers",
  async beforeCreate() {
    await this.$store.dispatch("getCustomers");
    await this.$store.dispatch("getGeneralSettings");
    await this.$store.dispatch("subscriptionRead");
  },
  computed: {
    customers() {
      return this.$store.getters.allCustomers;
    },
    settings() {
      return this.$store.getters.generalSettings;
    },
    subscriptions() {
      return this.$store.getters.subscriptions.map((s) => {
        s.title = s.title + " - " + s.interval;
        return s;
      });
    },
  },
  mounted() {},

  created() {
    // console.log(this.subscriptions);
  },

  data() {
    return {
      valuefield: "id",
      textfield: "title",
      addNewCustomerModalShow: false,
      stripeCATableFields: [{ key: "update_status", label: "" }, "name", "type", "account_id", "status", "onboarded", "actions"],

      createModal: {
        stripe: {
          email: "",
          type: "standard",
          country: "SE",
          // capabilities : {
          //   card_payments : {'requested' : true},
          //   transfers : {'requested' : true},
          // },
        },
        stripe_connect_account: {
          name: "",
          instance_id: "",
          type: "standard",
          account_id: "",
          status: "inactive",
        },
      },

      updateModal: {
        stripe_connect_account: {
          status: "",
        },
        id: "",
        instance_id: "",
      },

      deleteModal: {
        stripe: {
          account_id: "",
        },
        id: "",
        instance_id: "",
      },
    };
  },

  methods: {
    activeSubscription(customer) {
      if (customer["active_customer_subscription"] != null) {
        return customer["active_customer_subscription"]["subscription_id"];
      }

      return 0;
    },

    getActualSettingValue(setting_id, setting_value, customer_settings_object) {
      let foundIt = false;

      for (let i = 0; i < customer_settings_object.length; i++) {
        if (setting_id == customer_settings_object[i]["settings_id"]) {
          setting_value = customer_settings_object[i]["value"];
          foundIt = true;
        }
      }

      return foundIt ? setting_value : "";
    },

    updateCustomer(customerId) {
      const customer = this.$refs["customer_" + customerId][0].text;
      const organization_number = this.$refs["organization_number_" + customerId][0].text;
      const guid = this.$refs["guid_" + customerId][0].text;
      const secret_key = this.$refs["secret_key_" + customerId][0].text;
      const license_type = this.$refs["license_type_" + customerId][0].selectedrow;
      const lms_url = this.$refs["lms_url_" + customerId][0].text;
      const email = this.$refs["lms_email_" + customerId][0].text;

      let customerSettings = [];

      for (let i = 0; i < this.settings.length; i++) {
        const settingsValue = this.$refs[this.settings[i].name + "_" + customerId][0].text;
        const object = { settings_id: this.settings[i].id, customer_id: customerId, instance_id: customerId, value: settingsValue };
        customerSettings.push(object);
      }

      let form = {
        customerId,
        customer_name: customer,
        organization_number,
        guid,
        secret_key,
        // licence: license_type,
        lms_url,

        customer_settings: customerSettings,
      };

      form["customer"] = {
        customerid: customerId,
        name: customer,
        organization_number,
        guid,
        secret_key,
        // licence: license_type,
        lms_url,
        email,
      };

      form["customer_subscription"] = {
        subscription_id: license_type,
        active: true,
        last_paid: Date.now(),
        expiry: Date.now(),
      };

      form["customer_settings"] = customerSettings;

      this.$store.dispatch("updateCustomer", JSON.stringify(form)).then((result) => {
        if (result.success == true) {
          this.$fire({
            title: result.message,
            // text: "text",
            type: "success",
            timer: 3000,
          }).then(() => {
            // this.customers = this.$store.getters.allCustomers;
          });
        } else {
          this.$fire({
            title: result.message,
            // text: "text",
            type: "error",
            html: "",
          });
        }
      });
    },
    addNewCustomer() {
      const customer = this.$refs.newCustomer.text;
      const organization_number = this.$refs.newOrgNumber.text;
      const guid = this.$refs.newGuid.text;
      const secret_key = this.$refs.newSecretKey.text;
      const license_type = this.$refs.newLicense.selectedrow;
      const lms_url = this.$refs.newLmsUrl.text;
      const customer_email = this.$refs.customerEmail.text;

      const form = {
        customer: {
          name: customer,
          organization_number,
          guid,
          secret_key,
          customerid: 0,
          lms_url,
          email: customer_email,
        },
        customer_subscription: {
          subscription_id: license_type,
          active: true,
          last_paid: Date.now(),
          expiry: Date.now(),
        },
      };

      this.$store.dispatch("createCustomer", JSON.stringify(form)).then((result) => {
        if (result.success == true) {
          this.$fire({
            title: result.message,
            // text: "text",
            type: "success",
            timer: 3000,
          }).then(() => {
            this.addNewCustomerModalShow = false;
            this.resetFields();
          });
        } else {
          this.$fire({
            title: result.message,
            // text: "text",
            type: "error",
            html: "",
          });
        }
      });
    },
    showAddNewCustomerModal() {
      this.addNewCustomerModalShow = true;
    },

    showCreateAccountModal(customer) {
      this.createModal.stripe.email = customer.email;
      this.createModal.stripe_connect_account.instance_id = customer.customerid;
      this.$bvModal.show("create-account-modal");
    },

    showAccountDeletionModal(item) {
      this.$fire({
        title: "Warning",
        text: "Are you sure you want to delete this account?",
        type: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((r) => {
        if (r.value && r.value == true) {
          this.deleteModal.id = item.id;
          this.deleteModal.instance_id = item.instance_id;
          this.deleteModal.stripe.account_id = item.account_id;
          this.deleteAccount();

          // this.deleteSetting();
        }
      });
    },

    createAccount() {
      this.$bvModal.hide("create-account-modal");

      this.$store.dispatch("createStripeConnectAccount", JSON.stringify(this.createModal)).then((result) => {
        if (result.success == true) {
          // console.log(result);
          this.$fire({
            title: result.message,
            // text: "text",
            type: "success",
            timer: 3000,
          }).then(() => {});
        } else {
          this.$fire({
            title: result.message,
            // text: "text",
            type: "error",
            html: "",
          });
        }
      });
    },

    updateAccountStatus(value, account) {
      this.updateModal.id = account.id;
      this.updateModal.instance_id = account.instance_id;
      this.updateModal.stripe_connect_account.status = value == true ? "active" : "inactive";

      this.$store.dispatch("updateStripeConnectAccount", this.updateModal).then((result) => {
        if (result.success == true) {
          this.$fire({
            title: result.message,
            // text: "text",
            type: "success",
            timer: 3000,
          }).then(() => {});
        } else {
          // console.log(result);
          this.$fire({
            title: result.errors ? result.errors["stripe_connect_account.status"][0] : result.message,
            // text: "text",
            type: "error",
            html: "",
          });
        }
      });
    },

    deleteAccount() {
      this.$store.dispatch("deleteStripeConnectAccount", this.deleteModal).then((result) => {
        if (result.success == true) {
          this.$fire({
            title: result.message,
            // text: "text",
            type: "success",
            timer: 3000,
          }).then(() => {});
        } else {
          this.$fire({
            title: result.message,
            // text: "text",
            type: "error",
            html: "",
          });
        }
      });
    },

    hideModal(modalName) {
      this[modalName] = false;
    },

    resetFields() {
      this.$refs.newCustomer.text = "";
      this.$refs.newOrgNumber.text = "";
      this.$refs.newGuid.text = "";
      this.$refs.newSecretKey.text = "";
      this.$refs.newLmsUrl.text = "";
    },
  },
  components: {
    MyButton,
    MyInput,
    Selector,
    ToggleSimple,
  },
};
</script>
